import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ServicesService } from '../services.service';
import 'rxjs/add/operator/debounceTime';

import { Router } from '@angular/router';
import { Select2OptionData } from 'ng2-select2';
import {HttpErrorResponse} from '@angular/common/http';


@Component({
  selector: 'app-online-photo-order',
  templateUrl: './online-photo-order.component.html',
  styleUrls: ['./online-photo-order.component.css'],
})

export class OnlinePhotoOrderComponent implements OnInit {
    header      = 'l-header';
    navbar      = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    searchTerm  = new FormControl();
    searchResult;
    searchPhotoForm: FormGroup;
    shootNameOptions = [];
    clientId = '';
    alertBoxDisplay = false;
    alertBoxMessage = "";
    isPasted = false;
    schoolClientAlertBoxDisplay = false;
    schoolClientAlertBoxMessage = "";

  constructor(private router: Router, private _services: ServicesService) {
      this.createForm();
  }

  ngOnInit() {
      $('.tb-preloader-wave').fadeOut();
      $('#tb-preloader').delay(200).fadeOut('slow').remove();
  }
    private createForm() {

        this.searchPhotoForm = new FormGroup({
            // tslint:disable-next-line
            shootName:  new FormControl('', [Validators.required]),
        });

        this.searchTerm.valueChanges
            .debounceTime(400)
            .subscribe(data => {
                
                // console.log(data, this.searchResult);
                this._services.search_word(data).subscribe((response: any ) => {
                    //  console.log("data",response);
                     if(response === null){
                         return;
                     }
                     if(response.result == undefined || response.result.length == 0){
                         if(!this.isPasted){
                             this.alertBoxDisplay = true;
                             this.alertBoxMessage = " No school / client found for "+data;
                         }

                     }
                     else{
                        if(!this.isPasted){
                            this.alertBoxDisplay = false;
                            this.alertBoxMessage = "";
                        }
                    }

                    // if(!this.clientId){
                    //     this.alertBoxDisplay = true;
                    //     this.alertBoxMessage = "You need to select a value from listed fields.";
                    // }
                        this.isPasted = false;
                        this.searchResult = response.result;
                });
            });
    }

    getShoots(selected) {
        // console.log(selected);
        this.alertBoxDisplay = false;
        this.alertBoxMessage = "";

        this.clientId = selected;

        this._services.getShoots(selected).subscribe((data: any) => {
                this.shootNameOptions = data.result;
                if(!data.result.length){
                    this.alertBoxDisplay = true;
                    this.alertBoxMessage = "There aren’t any shoots available at the moment because the cut-off date for orders have been reached.";
                    this.isPasted = true;
                }
                // this.shootNameOptions.unshift({id: 0, shoot_name: 'Select Shoot Name'});
                // console.log(this.shootNameOptions);
            },
            (err: HttpErrorResponse) => {
                // this.isLoginError = true;
            }
        );
    }

    // searchPhoto() {
    // //  console.log('Client id--->' + this.clientId , 'shoot id--->' + this.searchPhotoForm.get('shootName').value);
    //
    //   if (this.searchPhotoForm.get('shootName').value) {
    //
    //       // this.router.navigate(['/product'],{ queryParams: { jobid: this.searchPhotoForm.get('shootName').value }});
    //       this.router.navigate(['/product', this.searchPhotoForm.get('shootName').value]);
    //
    //   }
    //
    // }

    searchPhoto() {
         console.log('Client id--->' + this.clientId , 'shoot id--->' + this.searchPhotoForm.get('shootName').value);

          if (this.searchPhotoForm.get('shootName').value) {
              this.router.navigate(['/jobphotoselection', this.searchPhotoForm.get('shootName').value]);
              // this.router.navigate(['/jobphotoselection'],{ queryParams: { jobid: this.searchPhotoForm.get('shootName').value }});

          }

        }

        pasteEvent(){
            this.isPasted = true;
            this.alertBoxDisplay = true;
            this.alertBoxMessage = "You need to select a value from listed fields.";
        }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/online-photo-order/online-photo-order.component.ts